/** Kinds of gift (madkhol-user `gift_type`). */
export enum GiftTypes {
  FREE_MANAGEMENT_FEE = 'FREE_MANAGEMENT_FEE',
  PREMIUM = 'PREMIUM',
}

export enum GiftTargetType {
  USER_ID = 'USER_ID',
  NATIONAL_ID = 'NATIONAL_ID',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}

export enum UserGiftStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}

export interface GiftType {
  id: number;
  type: GiftTypes;
  isActive: boolean;
}

/** One gift for one target (madkhol-user `user_gift`). The target may not have an account yet. */
export interface UserGift {
  id: number;
  giftTypeId: number;
  giftType: GiftType;
  targetType: GiftTargetType;
  /** Normalized by the server: lower-case email, E.164 phone, digits-only national id, user id as a string. */
  targetValue: string;
  status: UserGiftStatus;
  /** Last moment the gift can be used. A portfolio opened before it never pays a management fee. */
  expiresAt: string;
  /** PREMIUM only: months of Premium from the day the gift is applied. Null for other types. */
  premiumMonths: number | null;
  note: string | null;
  /**
   * First user that used it. For a fee gift this is informational — it keeps working until it expires. A PREMIUM gift
   * is used once: a value here means it was applied to that user.
   */
  usedByUserId: number | null;
  firstUsedAt: string | null;
  lastUsedAt: string | null;
  createdByEmployeeId: number;
  createdByEmployeeName: string;
  updatedByEmployeeId: number | null;
  createdAt: string;
  updatedAt: string;
}

export type FetchUserGiftsResponse = { items: UserGift[]; totalItems: number };

export type FetchGiftTypesResponse = GiftType[];

export type CreateUserGiftRequest = {
  giftTypeId: number;
  targetType: GiftTargetType;
  targetValue: string;
  expiresAt: string;
  /** PREMIUM only, and required there. */
  premiumMonths?: number;
  note?: string | null;
};

/** Send only what changes. Target and type can't change. */
export type UpdateUserGiftRequest = {
  id: number;
  status?: UserGiftStatus;
  expiresAt?: string;
  note?: string | null;
};
